import { Link } from "react-router-dom";
import type { Movie } from "@/types/movie";

interface MovieCardProps {
  movie: Movie;
  isFavorite?: boolean;
  onToggleFavorite?: (id: number) => void;
}

export default function MovieCard({
  movie,
  isFavorite = false,
  onToggleFavorite,
}: MovieCardProps) {
  return (
    <div className="group relative">
      <Link to={`/detail/${movie.id}`} className="block">
        <div className="relative aspect-[2/3] w-full overflow-hidden rounded-lg bg-background-200">
          <img
            src={movie.cover}
            alt={`${movie.title} 影视海报`}
            title={`${movie.title} 在线观看 - 日韩中文字幕在线观看`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute left-2 top-2 flex flex-col items-start gap-1">
            <span className="rounded-md bg-primary-500/92 px-2 py-0.5 text-xs text-background-50">
              {movie.type}
            </span>
            <span className="rounded-md bg-background-50/92 px-2 py-0.5 text-xs text-foreground-800">
              {movie.region}
            </span>
          </div>
          <div className="absolute inset-0 flex items-center justify-center bg-foreground-950/45 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-accent-500 text-background-50">
              <i className="ri-play-fill text-2xl" />
            </span>
          </div>
        </div>
        <h3 className="mt-3 line-clamp-1 text-sm font-medium text-foreground-950">
          {movie.title}
        </h3>
        <p className="mt-1 line-clamp-1 text-xs text-foreground-600">
          {movie.year} · {movie.originalTitle}
        </p>
        <div className="mt-1.5 flex items-center gap-2">
          <span className="flex items-center gap-0.5 text-xs font-medium text-accent-600">
            <span className="flex h-3.5 w-3.5 items-center justify-center">
              <i className="ri-star-fill text-xs" />
            </span>
            {movie.rating.toFixed(1)}
          </span>
          <span className="line-clamp-1 text-xs text-foreground-500">
            {movie.genres.join(" / ")}
          </span>
        </div>
        <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">
          {movie.synopsis}
        </p>
      </Link>

      {onToggleFavorite && (
        <button
          type="button"
          aria-label={isFavorite ? "取消收藏" : "收藏本片"}
          onClick={() => onToggleFavorite(movie.id)}
          className="absolute right-2 top-2 z-10 flex h-8 w-8 items-center justify-center rounded-full bg-foreground-950/45 text-background-50 backdrop-blur transition-colors hover:bg-foreground-950/65"
        >
          <i
            className={
              isFavorite ? "ri-heart-fill text-base text-accent-400" : "ri-heart-line text-base"
            }
          />
        </button>
      )}
    </div>
  );
}